import { ExternalStyles, Icon, IconProps, Theme, Tooltip, TooltipProps, useStyles } from 'bold-ui'
import { CSSProperties } from 'react'

export interface InfoIconProps extends IconProps, Pick<TooltipProps, 'text'> {
  tooltipStyle?: ExternalStyles
}

export function InfoIcon(props: InfoIconProps) {
  const { text, style, tooltipStyle, ...rest } = props
  const { css, classes } = useStyles(createStyles)

  return (
    <Tooltip text={text} style={tooltipStyle}>
      <Icon style={css(classes.icon, style)} size={1} {...rest} />
    </Tooltip>
  )
}

const createStyles = (theme: Theme) => ({
  icon: {
    '&:hover': {
      color: theme.pallete.primary.main,
    },
  } as CSSProperties,
})
